/*
 * IronTrail scroll motion: reveal-on-enter, hero stat count-up, hero parallax.
 * Everything is gated on the `it-motion` class set by snippets/irontrail-motion.liquid.
 * If this file never runs, that snippet's watchdog drops the class and the page
 * renders normally, so nothing here is load-bearing.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  if (window.__itMotionReady) window.__itMotionReady();
  if (!('IntersectionObserver' in window)) { root.classList.remove('it-motion'); return; }

  /* --- reveals: [selector, stagger step ms]; siblings cascade in DOM order --- */
  var GROUPS = [
    ['.ith__tag, .ith__title, .ith__body, .ith__cta, .ith__stats', 90],
    ['.itc__head', 0], ['.itc__card', 55],
    ['.itb__head', 0], ['.itb__card', 55],
    ['.itt__cell', 70]
  ];
  var MAX_STEPS = 8;

  var revealIO = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i].isIntersecting) continue;
      entries[i].target.classList.add('it-in');
      revealIO.unobserve(entries[i].target);
    }
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  function bindReveals(scope) {
    for (var g = 0; g < GROUPS.length; g++) {
      var nodes = scope.querySelectorAll(GROUPS[g][0]);
      var step = GROUPS[g][1];
      var seen = [];
      var counts = [];
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.getAttribute('data-it-reveal')) continue;
        el.setAttribute('data-it-reveal', '1');
        var p = el.parentNode;
        var k = seen.indexOf(p);
        if (k === -1) { k = seen.push(p) - 1; counts[k] = 0; }
        var n = counts[k]++;
        if (step) el.style.transitionDelay = (Math.min(n, MAX_STEPS) * step) + 'ms';
        revealIO.observe(el);
      }
    }
  }

  /* --- stat count-up: keeps prefixes/suffixes ('R1 500+', '30 days', 'SA') --- */
  function countUp(el) {
    var raw = el.textContent.trim();
    var m = raw.match(/^(\D*?)(\d[\d\s,]*\d|\d)(.*)$/);
    if (!m) return;
    var target = parseInt(m[2].replace(/[\s,]/g, ''), 10);
    if (!isFinite(target) || target > 1000000) return;
    var sep = /\s/.test(m[2]) ? ' ' : (m[2].indexOf(',') > -1 ? ',' : '');
    var fmt = function (n) {
      var s = String(n);
      if (sep) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return m[1] + s + m[3];
    };
    var t0 = null, dur = 900;
    el.textContent = fmt(0);
    requestAnimationFrame(function tick(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      el.textContent = fmt(Math.round(target * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = raw; // restore the authored string exactly
    });
  }

  var statIO = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i].isIntersecting) continue;
      countUp(entries[i].target);
      statIO.unobserve(entries[i].target);
    }
  }, { threshold: 0.6 });

  function bindStats(scope) {
    var nodes = scope.querySelectorAll('.ith__stat b');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-it-count')) continue;
      nodes[i].setAttribute('data-it-count', '1');
      statIO.observe(nodes[i]);
    }
  }

  /* --- hero parallax: grid, glow and contours drift at different rates --- */
  var heroes = [];
  var ticking = false;

  function bindHeroes(scope) {
    var nodes = scope.querySelectorAll('.ith');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-it-parallax')) continue;
      nodes[i].setAttribute('data-it-parallax', '1');
      heroes.push({
        el: nodes[i],
        grid: nodes[i].querySelector('.ith__grid'),
        glow: nodes[i].querySelector('.ith__glow'),
        topo: nodes[i].querySelector('.ith__topo')
      });
    }
  }

  function shift(node, px) {
    if (node) node.style.transform = 'translate3d(0,' + px.toFixed(1) + 'px,0)';
  }

  function onFrame() {
    ticking = false;
    var vh = window.innerHeight;
    for (var i = 0; i < heroes.length; i++) {
      var h = heroes[i];
      var r = h.el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) continue; // off-screen: skip the work
      var y = -r.top;
      shift(h.grid, y * 0.12);
      shift(h.glow, y * 0.22);
      shift(h.topo, y * -0.06);
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(onFrame);
  }

  /* --- wire up, and re-wire when the theme editor swaps a section --- */
  function init(scope) {
    bindReveals(scope);
    bindStats(scope);
    bindHeroes(scope);
    onScroll();
  }

  init(document);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
}());
